import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'material-ui';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';

export class TypeCascade extends React.PureComponent {
    renderRecursiveType = (type, prevPath = []) => {
        return Object.keys(type)
            .sort((a, b) => a - b)
            .map(key => {
                const cur = type[key];
                const hasChildren = typeof cur === 'object';
                if (hasChildren) {
                    return (
                        <MenuItem
                            key={key}
                            rightIcon={<ArrowDropRight />}
                            primaryText={key}
                            menuItems={this.renderRecursiveType(cur, prevPath.concat(key))}
                        />
                    );
                }
                return (
                    <MenuItem
                        key={key}
                        primaryText={key}
                        onTouchTap={() => {
                            const path = prevPath.concat(key);
                            if (this.props.onClick) {
                                this.props.onClick(path.join('.'), path);
                            }
                        }}
                    />
                );
            });
    };

    render() {
        const { type, name, label } = this.props;
        return <MenuItem primaryText={label || name} menuItems={this.renderRecursiveType(type, [name])} />;
    }
}

TypeCascade.propTypes = {
    type: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    onClick: PropTypes.func
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/components/TypeCascade.js
 **/